module.exports = __webpack_public_path__ + "img/hw-q600b.4a53fd1b.png";